import { combineReducers } from "redux";
import { contractsState } from "./contractsReducer";

export const contractsReducers = combineReducers({
    contractsState: contractsState
});
